import { NO, PENDING, YES } from '../constants';

export const PROMOTIONS_TYPE = 'PROMOTIONS';
export const PROMOTIONS_TITLE = 'The Home Depot';
export const LOCAL_AD_TYPE = 'LOCAL_AD';
export const LOCAL_AD_TITLE = 'Local Ad';
export const PRO_TYPE = 'PRO';
export const PRO_TITLE = 'Pro Communications';
export const PHONE_TITLE = 'Phone Calls';
export const PHONE_TYPE = 'DEFAULT';
export const SBOTD_TYPE = 'SPECIAL_BUY_OF_THE_DAY';
export const SBOTD_TITLE = 'Special Buy of the Day';
export const RETARGETING_TYPE = 'RETARGETING';
export const SURVEYS_TYPE = 'SURVEYS';
export const SURVEYS_TITLE = 'Surveys';
export const PERSONALIZED_OFFERS_TYPE = 'Personalized Offers';
export const PROGRAM_BENEFITS_TYPE = 'Program Benefits';
export const E_STATMENT_TYPE = 'eStatment';
export const MEMBER_EVENTS_TYPE = 'Member Events';
export const BUSINESS_TOOLS_TYPE = 'Business Tools';
export const PERSONALIZED_OFFERS_TITLE = 'Personalized Offers';
export const PROGRAM_BENEFITS_TITLE = 'Program Benefits';
export const E_STATEMENT_TITLE = 'E-Statement';
export const MEMBER_EVENTS_TITLE = 'Member Events';
export const BUSINESS_TOOLS_TITLE = 'Business Tools';
export const LANGUAGE_PREFERENCE_TITLE = 'Language';
export const LANGUAGE_PREFERENCE_TYPE = 'LANGUAGE_PREFERENCE';
export const ORDER_STATUS_TITLE = 'Order Status';
export const ORDER_STATUS_TYPE = 'ORDER_PREFERENCE';
export const PRO_ERECEIPT_TITLE = 'eReceipt';
export const PRO_ERECEIPT_TYPE = 'eReceipt_PREFERENCE';

export function initialSurveyEmailTableData() {
  return {
    [SURVEYS_TITLE]: {
      subText: 'Provide your feedback by subscribing to survey emails.',
      value: YES,
      type: SURVEYS_TYPE,
    }
  };
}

export function initialEmailTableData() {
  return {
    [PROMOTIONS_TITLE]: {
      subText: 'Get exclusive savings, services, project ideas and more delivered to your inbox.',
      value: NO,
      type: PROMOTIONS_TYPE
    },
    [PRO_TITLE]: {
      subText: `Get jobs done right with up-to-date special offers, savings,
      pro benefits and more, at your fingertips.`,
      value: NO,
      type: PRO_TYPE
    },
    [SBOTD_TITLE]: {
      subText: 'Sign up now to get one-day only savings sent right to you daily.',
      value: NO,
      type: SBOTD_TYPE
    },
    [LOCAL_AD_TITLE]: {
      subText: 'Stay in the know about the latest savings and updates from your local store, right to your inbox.',
      value: NO,
      type: LOCAL_AD_TYPE
    }
  };
}
export function initialProXtraTableData() {
  return {
    [PERSONALIZED_OFFERS_TITLE]: {
      subText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
      value: YES,
      type: PERSONALIZED_OFFERS_TYPE
    },
    [PROGRAM_BENEFITS_TITLE]: {
      subText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. '
        + 'Duis aute irure dolor in reprehenderit in voluptate',
      value: YES,
      type: PROGRAM_BENEFITS_TYPE
    },
    [E_STATEMENT_TITLE]: {
      subText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
      value: YES,
      type: E_STATMENT_TYPE
    },
    [MEMBER_EVENTS_TITLE]: {
      subText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. '
        + 'Duis aute irure dolor in reprehenderit in voluptate',
      value: YES,
      type: MEMBER_EVENTS_TYPE
    },
    [BUSINESS_TOOLS_TITLE]: {
      subText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, quis nostrud exercitation',
      value: YES,
      type: BUSINESS_TOOLS_TYPE
    }
  };
}

export const typeMap = {
  [PROMOTIONS_TYPE]: PROMOTIONS_TITLE,
  [LOCAL_AD_TYPE]: LOCAL_AD_TITLE,
  [PRO_TYPE]: PRO_TITLE,
  [SBOTD_TYPE]: SBOTD_TITLE,
  [PHONE_TYPE]: PHONE_TITLE,
  [SURVEYS_TYPE]: SURVEYS_TITLE
};

export function initialSmsTableData() {
  return {
    [PROMOTIONS_TITLE]: {
      subText: 'Get exclusive savings, services, project ideas and more delivered to your inbox.',
      value: NO,
      type: PROMOTIONS_TYPE,
    },
    [PRO_TITLE]: {
      subText: `Get jobs done right with up-to-date special offers, savings,
      pro benefits and more, at your fingertips.`,
      value: NO,
      type: PRO_TYPE,
    }
  };
}

export function initialLanguagePreferenceTableData() {
  return {
    [LANGUAGE_PREFERENCE_TITLE]: {
      subText: 'Let us know in which language you would like to be communicated. Please keep in '
        + 'mind that while we\'ll strive to honor your preference, there may be limitations at times.',
      value: null,
      type: LANGUAGE_PREFERENCE_TYPE,
    },
  };
}
export function initialOrderPreferences() {
  return {
    [ORDER_STATUS_TITLE]: {
      subText: 'Get delivery updates and more for your orders',
      value: YES,
      type: ORDER_STATUS_TYPE,
    }
  };
}
export function initialEReceiptPreferences() {
  return {
    [PRO_ERECEIPT_TITLE]: {
      subText: 'Receive eReceipts when you make a purchase in store.',
      value: NO,
      type: PRO_ERECEIPT_TYPE,
    }
  };
}

export function initialSmsTelemarketingTableData() {
  return {
    [PROMOTIONS_TITLE]: {
      subText: 'Get exclusive savings, services, project ideas and more delivered to your inbox.',
      value: NO,
      type: PROMOTIONS_TYPE,
    },
    [PRO_TITLE]: {
      subText: `Get jobs done right with up-to-date special offers, savings,
      pro benefits and more, at your fingertips.`,
      value: NO,
      type: PRO_TYPE,
    },
    [PHONE_TITLE]: {
      subText: 'Hear from The Home Depot about products, services, and special offers by phone call',
      value: YES,
      type: PHONE_TYPE
    }
  };
}
